import script from "./systemCheck.vue?vue&type=script&setup=true&name=systemCheck&lang=js"
export * from "./systemCheck.vue?vue&type=script&setup=true&name=systemCheck&lang=js"

const __exports__ = script;

export default __exports__